import { applyRESTQueries } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function applyCasinoPlayerActivityAPIQueries(message) {
    return applyRESTQueries(ConnectionNames.casinoPlayerActivity, message);
}
//# sourceMappingURL=ApplyCasinoPlayerActivityAPIQueries.js.map